export enum PlayPermissionTypes {
  FREE_CONTENT = 'FREE_CONTENT',
  FREE_ISP = 'FREE_ISP',
  SUBSCRIBED_USER = 'SUBSCRIBED_USER',
  ONLINE_SCREENING_TICKET = 'ONLINE_SCREENING_TICKET',
  SUB_REQ_AND_DATA_CONTRACT = 'SUB_REQ_AND_DATA_CONTRACT',
  SUBSCRIPTION_REQUIRED = 'SUBSCRIPTION_REQUIRED',
  ONLINE_SCREENING_TICKET_REQUIRED = 'ONLINE_SCREENING_TICKET_REQUIRED',
  LOGIN_REQUIRED = 'LOGIN_REQUIRED',
  IRAN_ACCESS = 'IRAN_ACCESS',
  CONTENT_NOT_READY = 'CONTENT_NOT_READY',
  LOADING = 'LOADING',
}
